import(/* webpackMode: "eager" */ "/app/src/app/products/[pid]/layout.tsx");
